import { getActiveOrganization } from "selectors/organizations";
import { getLanguage } from "selectors/texts";
import { mainApi } from "api";
import Async from "utils/Async";
import CancellationActions from "const/CancellationActions";
import MainApiRoutes from "const/MainApiRoutes";
import MetaDataActions from "actions/MetaDataActions";
import Storage from "utils/Storage";

const REQUEST_EXTRA_DELAY = 1000;

export default class StripeActions {
  static CREATE_BILLING_PORTAL_SESSION_START = "stripe/CREATE_BILLING_PORTAL_SESSION_START";

  static CREATE_BILLING_PORTAL_SESSION_DONE = "stripe/CREATE_BILLING_PORTAL_SESSION_DONE";

  static CREATE_BILLING_PORTAL_SESSION_ERROR = "stripe/CREATE_BILLING_PORTAL_SESSION_ERROR";

  static CREATE_SETUP_CHECKOUT_SESSION_START = "stripe/CREATE_SETUP_CHECKOUT_SESSION_START";

  static CREATE_SETUP_CHECKOUT_SESSION_DONE = "stripe/CREATE_SETUP_CHECKOUT_SESSION_DONE";

  static CREATE_SETUP_CHECKOUT_SESSION_ERROR = "stripe/CREATE_SETUP_CHECKOUT_SESSION_ERROR";

  static CREATE_UPSELL_CHECKOUT_SESSION_START = "stripe/CREATE_UPSELL_CHECKOUT_SESSION_START";

  static CREATE_UPSELL_CHECKOUT_SESSION_DONE = "stripe/CREATE_UPSELL_CHECKOUT_SESSION_DONE";

  static CREATE_UPSELL_CHECKOUT_SESSION_ERROR = "stripe/CREATE_UPSELL_CHECKOUT_SESSION_ERROR";

  static FULLFILL_CHECKOUT_SESSION_START = "stripe/FULLFILL_CHECKOUT_SESSION_START";

  static FULLFILL_CHECKOUT_SESSION_DONE = "stripe/FULLFILL_CHECKOUT_SESSION_DONE";

  static FULLFILL_CHECKOUT_SESSION_ERROR = "stripe/FULLFILL_CHECKOUT_SESSION_ERROR";

  static SUBMIT_CANCELLATION_START = "stripe/SUBMIT_CANCELLATION_START";

  static SUBMIT_CANCELLATION_DONE = "stripe/SUBMIT_CANCELLATION_DONE";

  static SUBMIT_CANCELLATION_ERROR = "stripe/SUBMIT_CANCELLATION_ERROR";

  static createBillingPortalSession() {
    return async(dispatch, getState) => {
      dispatch({ type: StripeActions.CREATE_BILLING_PORTAL_SESSION_START });

      const { STRIPE, BILLING_PORTAL } = MainApiRoutes;

      const locale = getLanguage(getState());

      const { url } = await mainApi.post(STRIPE + BILLING_PORTAL, null, { redirectUrl: window.location.origin, locale });

      await Async.delay(REQUEST_EXTRA_DELAY);
      if (url) {
        dispatch({ type: StripeActions.CREATE_BILLING_PORTAL_SESSION_DONE, payload: { url } });

        return url;
      }
      dispatch({ type: StripeActions.CREATE_BILLING_PORTAL_SESSION_ERROR });

      return null;
    };
  }

  static createSetupCheckoutSession() {
    return async(dispatch, getState) => {
      dispatch({ type: StripeActions.CREATE_SETUP_CHECKOUT_SESSION_START });

      const { STRIPE, CHECKOUT_SESSION, SETUP } = MainApiRoutes;

      const activeOrganization = getActiveOrganization(getState());

      const locale = getLanguage(getState());

      const firstPromoterTid = activeOrganization.firstPromoterTid || Storage.cookieValue("_fprom_tid") || null;

      const { url } = await mainApi.post(
        STRIPE + CHECKOUT_SESSION + SETUP,
        null,
        {
          locale,
          redirectUrl: window.location.origin,
          ...(firstPromoterTid && { firstPromoterTid })
        }
      );

      await Async.delay(REQUEST_EXTRA_DELAY);
      if (url) {
        dispatch({ type: StripeActions.CREATE_SETUP_CHECKOUT_SESSION_DONE, payload: { url } });

        return url;
      }
      dispatch({ type: StripeActions.CREATE_SETUP_CHECKOUT_SESSION_ERROR });

      return null;
    };
  }

  static createUpsellCheckoutSession(businessId) {
    return async(dispatch, getState) => {
      dispatch({ type: StripeActions.CREATE_UPSELL_CHECKOUT_SESSION_START });

      const { STRIPE, CHECKOUT_SESSION, UPSELL } = MainApiRoutes;

      const locale = getLanguage(getState());

      const redirectUrl = `${window.location.origin}${window.location.pathname}`;

      const { url } = await mainApi.post(
        STRIPE + CHECKOUT_SESSION + UPSELL,
        null,
        { businessId, locale, redirectUrl }
      );

      await Async.delay(REQUEST_EXTRA_DELAY);
      if (url) {
        dispatch({ type: StripeActions.CREATE_UPSELL_CHECKOUT_SESSION_DONE, payload: { url } });

        return url;
      }
      dispatch({ type: StripeActions.CREATE_UPSELL_CHECKOUT_SESSION_ERROR });

      return null;
    };
  }

  static fullfillCheckoutSession(sessionId) {
    return async(dispatch) => {
      dispatch({ type: StripeActions.FULLFILL_CHECKOUT_SESSION_START });

      const { STRIPE, CHECKOUT_SESSION, FULLFILL } = MainApiRoutes;

      const { ok } = await mainApi.post(`${STRIPE + CHECKOUT_SESSION}/${sessionId + FULLFILL}`);

      await Async.delay(REQUEST_EXTRA_DELAY);
      if (ok) {
        dispatch({ type: StripeActions.FULLFILL_CHECKOUT_SESSION_DONE });

        return true;
      }
      dispatch({ type: StripeActions.FULLFILL_CHECKOUT_SESSION_ERROR });

      return false;
    };
  }

  static submitCancellation({
    action,
    feedback,
    feedbackRequestId,
    requestId,
    organizationId,
    subscriptionId
  }) {
    return async(dispatch) => {
      dispatch({ type: StripeActions.SUBMIT_CANCELLATION_START });

      const result = await mainApi.post(
        MainApiRoutes.STRIPE + MainApiRoutes.CANCELLATION,
        null,
        {
          action,
          feedback,
          requestId,
          organizationId,
          subscriptionId,
          ...(feedbackRequestId && { feedbackRequestId })
        }
      );

      dispatch({ type: result.ok ? StripeActions.SUBMIT_CANCELLATION_DONE : StripeActions.SUBMIT_CANCELLATION_ERROR });
      if (result.ok && action !== CancellationActions.FEEDBACK) {
        dispatch(MetaDataActions.fetchPricesList());
      }

      return result.ok ? result : null;
    };
  }
}
